import React, { Fragment } from "react";

import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import logo from "@assets/logo.png";

const NavSection = () => {
  const renderTitle = () => {
    return "Track Order";
  };

  const renderIcon = () => {
    return (
      <img style={{ height: "40px", borderRadius: "50%" }} src={logo} alt="" />
    );
  };

  return (
    <Fragment>
      <IconButton
        size="large"
        edge="start"
        color="default"
        aria-label="open drawer"
        sx={{
          display: { color: "#1976d2" },
          cursor: "pointer",
        }}
      >
        {renderIcon()}
      </IconButton>

      <Typography
        variant="h6"
        noWrap
        component="div"
        sx={{ display: { xs: "none", sm: "block", color: "#1976d2" } }}
      >
        {renderTitle()}
      </Typography>
    </Fragment>
  );
};

export default NavSection;
